<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      title="选择物流单号"
      width="400px"
      center
      :visible="visible"
      @close="closeDialog()"
    >
      <div v-if="deliveryInfo.length > 0" style="line-height: 30px">
        <el-row style="color: #000">
          <el-col :span="11">快递公司</el-col>
          <el-col :span="11" style="text-align: right">快递单号</el-col>
          <el-col :span="2">&nbsp;</el-col>
        </el-row>
        <div
          v-for="(item, index) in deliveryInfo"
          :key="index"
          style="cursor: pointer"
          @click="showExpressInfo(item)"
        >
          <el-row>
            <el-col :span="11">{{ item.express_name }}</el-col>
            <el-col :span="11" style="text-align: right">{{
              item.delivery_no
            }}</el-col>
            <el-col :span="2" style="text-align: right"
              ><i class="el-icon-arrow-right"></i
            ></el-col>
          </el-row>
        </div>
      </div>
      <div v-else>暂无快递信息</div>
    </el-dialog>
    <ExpressInfo
      ref="expressInfo"
      :delivery-no="delivery_no"
      :express-no="express_no"
      :order-no="order_no"
      :visible.sync="expressInfoVisible"
    />
  </div>
</template>

<script>
import ExpressInfo from "../ExpressInfo";
export default {
  name: "ExpressCheck",
  components: { ExpressInfo },
  data() {
    return {
      express_no: "",
      delivery_no: "",
      order_no: "",
      expressInfoVisible: false,
      deliveryInfo: [],
    };
  },
  props: {
    visible: Boolean,
  },
  methods: {
    closeDialog() {
      this.$emit("update:visible", false);
    },
    showExpressInfo(item) {
      this.expressInfoVisible = true;
      this.express_no = item.express_no;
      this.delivery_no = item.delivery_no;
      const { express_no, delivery_no, order_no } = this;
      this.$refs.expressInfo.send({ express_no, delivery_no, order_no });
    },
    send({ deliveryNo }) {
      this.$.http.get("index/express", { no: deliveryNo }).then((res) => {
        const { express, order_no } = res.data;
        this.deliveryInfo = express || [];
        this.order_no = order_no;
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ExpressCheck/index.vue